module.exports = __webpack_public_path__ + "media/images/astronaut_with_map-037c5cd84bee414c8114aec1bd930c71.svg";